import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=58821b56&scoped=true&"
import script from "./AddressForm.vue?vue&type=script&lang=ts&"
export * from "./AddressForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=58821b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58821b56",
  null
  
)

export default component.exports